import { render, staticRenderFns } from "./list.vue?vue&type=template&id=79edb91c&"
import script from "./list.vue?vue&type=script&scoped=true&lang=js&"
export * from "./list.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports